import { KeyboardEvent, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Drawer, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
//Iconos
import {
	KeyboardArrowDown,
	KeyboardArrowRight,
	KeyboardDoubleArrowLeft,
	KeyboardDoubleArrowRight,
	FiberManualRecord,
} from '@mui/icons-material';
// Styles
import styles from './styles/drawer-layout.component.module.css';
// Assets
import logo from '../assets/svg/logo-purple.svg';
// Components
import { getRouteList } from '../router/routes';
import { RootState } from '../store';
import { useSelector } from 'react-redux';

interface IProps {
	open: boolean;
	toggleDrawer: () => void;
	drawerWidth: number;
	arrowToggle: boolean;
	setArrowToggle: (arg: boolean) => void;
	window?: () => Window;
}

const widthArrow: number = 80;

const DrawerLayout = ({
	open,
	toggleDrawer,
	drawerWidth,
	arrowToggle,
	setArrowToggle,
	window,
}: IProps) => {
	const matches = useMediaQuery(useTheme().breakpoints.down('md'));
	const navigate = useNavigate();
	const container = window !== undefined ? () => window().document.body : undefined;
	const [arrowToggleMain, setArrowToggleMain] = useState<boolean>(false);
	const [selectMenu, setSelectMenu] = useState<number>(0);
	const location = useLocation();
	const { role } = useSelector((state: RootState) => state.users);

	// Marca como activa la sección de la URL actual (p. ej. al recargar en /proyectos)
	useEffect(() => {
		const index = getRouteList(role)?.findIndex(
			(menu) =>
				!menu.hideMenu &&
				(location.pathname === menu.link ||
					location.pathname.startsWith(`${menu.link}/`))
		);
		if (index !== undefined && index >= 0) setSelectMenu(index);
	}, [location.pathname, role]);

	const toogleMenu = (menu: number, redirect?: string) => {
		setSelectMenu(menu);
		navigate(redirect || '/inicio');
		toggleDrawer();
	};

	const toggleArrow = () => {
		setArrowToggle(!arrowToggle);
		setArrowToggleMain(!arrowToggleMain);
	};

	const onKeyActivate = (action: () => void) => (event: KeyboardEvent) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			action();
		}
	};
	return (
		<Box
			component="nav"
			sx={{
				width: { md: arrowToggle && !matches ? widthArrow : drawerWidth },
				flexShrink: { md: 0 },
				transform: {
					width: { md: arrowToggle && !matches ? widthArrow : drawerWidth },
				},
				transition: (theme) =>
					theme.transitions.create('all', {
						duration: theme.transitions.duration.shortest,
					}),
			}}
			aria-label="mailbox folders"
			position={'relative'}
		>
			{!matches && (
				<Box
					className={styles.arrowMaximus}
					onClick={toggleArrow}
					onKeyDown={onKeyActivate(toggleArrow)}
					role="button"
					tabIndex={0}
					aria-label={arrowToggle ? 'Expandir menú' : 'Colapsar menú'}
				>
					{arrowToggle ? (
						<KeyboardDoubleArrowRight />
					) : (
						<KeyboardDoubleArrowLeft />
					)}
				</Box>
			)}
			<Drawer
				onMouseEnter={() => arrowToggleMain && setArrowToggle(false)}
				onMouseLeave={() => arrowToggleMain && setArrowToggle(true)}
				container={matches ? container : null}
				variant={matches ? 'temporary' : 'permanent'}
				open={matches ? open : true}
				onClose={toggleDrawer}
				ModalProps={{
					keepMounted: true,
				}}
				sx={{
					display: {
						xs: matches ? 'block' : 'none',
						md: matches ? 'none' : 'block',
					},
					'& .MuiDrawer-paper': {
						boxSizing: 'border-box',
						width: arrowToggle && !matches ? widthArrow : drawerWidth,
						background: 'var(--color-sidebar-bg, #eeeef0)',
						color: 'var(--color-sidebar-text, #744cb4)',
						borderRight: '1px solid var(--color-sidebar-border, #dcdce0)',
						transform: {
							width: arrowToggle && !matches ? widthArrow : drawerWidth,
						},
						transition: (theme) =>
							theme.transitions.create('all', {
								duration: theme.transitions.duration.shortest,
							}),
					},
				}}
			>
				<Box
					component="div"
					display="flex"
					alignItems="center"
					justifyContent="center"
					padding={3}
					sx={{ width: '100%' }}
				>
					<img
						src={logo}
						alt="logo"
						style={{ width: 100, cursor: 'pointer' }}
						onClick={() => toogleMenu(0, '/inicio')}
					/>
				</Box>
				<Box padding={arrowToggle && !matches ? 2 : 2.5}>
					<ul
						className={styles.menuDrawer}
						data-small={arrowToggle && !matches ? 'true' : 'false'}
					>
						{getRouteList(role)?.map(
							(menu, i) =>
								!menu.hideMenu && (
									<li key={i}>
										<div
											data-active={
												selectMenu === i ? 'true' : 'false'
											}
											role="button"
											tabIndex={0}
											aria-label={menu.title}
											aria-current={
												selectMenu === i ? 'page' : undefined
											}
											onKeyDown={onKeyActivate(() =>
												toogleMenu(
													i,
													!menu.submenu ? menu.link : undefined
												)
											)}
											style={
												arrowToggle
													? {
															display: 'flex',
															justifyContent: 'center',
															gap: '10px',
													  }
													: { display: 'flex', gap: '10px' }
											}
											onClick={() =>
												toogleMenu(
													i,
													!menu.submenu ? menu.link : undefined
												)
											}
										>
											{menu.icon}
											<span>{menu.title}</span>
											{arrowToggle && !matches
												? null
												: selectMenu === i
												? menu.submenu && <KeyboardArrowDown />
												: menu.submenu && <KeyboardArrowRight />}
										</div>
										{menu.submenu && (
											<ul
												data-active={
													selectMenu === i ? 'true' : 'false'
												}
												className={styles.submenuDrawer}
											>
												{menu.submenu.map(
													(submenu: any) =>
														!submenu.hideMenu && (
															<li
																key={
																	menu.link +
																	submenu.link
																}
																onClick={() =>
																	toogleMenu(
																		i,
																		menu.link +
																			submenu.link
																	)
																}
																onKeyDown={onKeyActivate(
																	() =>
																		toogleMenu(
																			i,
																			menu.link +
																				submenu.link
																		)
																)}
																role="button"
																tabIndex={0}
																data-active={
																	location.pathname ===
																	menu.link +
																		submenu.link
																}
															>
																<span
																	style={
																		arrowToggle
																			? {
																					fontSize:
																						'10px',
																			  }
																			: {
																					fontSize:
																						'12px',
																			  }
																	}
																>
																	<FiberManualRecord
																		style={{
																			fontSize: 7,
																			marginRight: 10,
																		}}
																	/>
																	{submenu.title}
																</span>
															</li>
														)
												)}
											</ul>
										)}
									</li>
								)
						)}
					</ul>
				</Box>
			</Drawer>
		</Box>
	);
};

export default DrawerLayout;
